export const ErrorCodes = {
   circular_prereq: _js('Circular reference in prerequisites.'),
   self_prereq: _js('Cannot add guide as a prerequisite of itself.'),
};
